import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import SobreMi from './components/sections/SobreMi';
import MiLibro from './components/sections/MiLibro';
import Tarot from './components/sections/Tarot';
import Contacto from './components/sections/Contacto';
import DaisyEdges from './components/DaisyEdges';
import EventPopup from './components/EventPopup';

function Starfield() {
  const stars = Array.from({ length: 18 });
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden -z-0">
      {stars.map((_, i) => {
        const top = Math.random() * 100;
        const left = Math.random() * 100;
        const size = 2 + Math.random() * 2;
        const delay = Math.random() * 5;
        return (
          <span
            key={i}
            className="absolute rounded-full bg-[#c7a06b] opacity-60"
            style={{
              top: `${top}%`,
              left: `${left}%`,
              width: size,
              height: size,
              animation: `twinkle 4.5s ease-in-out ${delay}s infinite`
            }}
          />
        );
      })}
    </div>
  );
}

function App() {
  const [tab, setTab] = useState('sobre');
  const [popupKey, setPopupKey] = useState(0);

  // Open the event popup on initial page load
  useEffect(() => {
    setPopupKey((k) => k + 1);
  }, []);

  // Open the event popup every time the user navigates to "Sobre Mí"
  const handleTabChange = (next) => {
    if (next === 'sobre') {
      setPopupKey((k) => k + 1);
    }
    setTab(next);
  };

  // Remove the platform-injected badge if present
  useEffect(() => {
    const removeBadge = () => {
      const el = document.getElementById('emergent-badge');
      if (el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    };
    removeBadge();
    const interval = setInterval(removeBadge, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App relative min-h-screen w-full bg-[#fbf1dc] overflow-x-hidden">
      <Starfield />

      {/* Page-level daisy edges that re-bloom on tab change */}
      <div key={`daisies-${tab}`}>
        <DaisyEdges pageKey={tab} />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-[46px] sm:px-20 md:px-24 lg:px-28">
        <Header active={tab} onChange={handleTabChange} />

        <main className="mt-10 pb-4 animate-[fadeIn_0.6s_ease-out]" key={tab}>
          {tab === 'sobre' && <SobreMi />}
          {tab === 'libro' && <MiLibro />}
          {tab === 'tarot' && <Tarot />}
          {tab === 'contacto' && <Contacto />}
        </main>

        <Footer />
      </div>

      <EventPopup triggerKey={popupKey} />
    </div>
  );
}

export default App;
